import { render, staticRenderFns } from "./ThePvpLink.vue?vue&type=template&id=5c9bb947"
import script from "./ThePvpLink.vue?vue&type=script&lang=ts"
export * from "./ThePvpLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports